var PassThrough = require('stream').PassThrough;

var getInfo = require('./info');

var utils = require('./utils');

var formatUtils = require('./format-utils');

var urlUtils = require('./url-utils');

var sig = require('./sig');

var miniget = require('miniget');

var m3u8stream = require('m3u8stream');

var _require = require('m3u8stream'),
    parseTimestamp = _require.parseTimestamp;
/**
 * @param {string} link
 * @param {!Object} options
 * @returns {ReadableStream}
 */


var ytdl = function ytdl(link, options) {
  var stream = createStream(options);
  ytdl.getInfo(link, options).then(function (info) {
    downloadFromInfoCallback(stream, info, options);
  }, stream.emit.bind(stream, 'error'));
  return stream;
};

module.exports = ytdl;
ytdl.getBasicInfo = getInfo.getBasicInfo;
ytdl.getInfo = getInfo.getInfo;
ytdl.chooseFormat = formatUtils.chooseFormat;
ytdl.filterFormats = formatUtils.filterFormats;
ytdl.validateID = urlUtils.validateID;
ytdl.validateURL = urlUtils.validateURL;
ytdl.getURLVideoID = urlUtils.getURLVideoID;
ytdl.getVideoID = urlUtils.getVideoID;
ytdl.cache = {
  sig: sig.cache,
  info: getInfo.cache,
  watch: getInfo.watchPageCache,
  cookie: getInfo.cookieCache
};
ytdl.version = require('../package.json').version;

var createStream = function createStream(options) {
  var stream = new PassThrough({
    highWaterMark: options && options.highWaterMark || 1024 * 512
  });

  stream._destroy = function () {
    stream.destroyed = true;
  };

  return stream;
};

var pipeAndSetEvents = function pipeAndSetEvents(req, stream, end) {
  // Forward events from the request to the stream.
  ['abort', 'request', 'response', 'error', 'redirect', 'retry', 'reconnect'].forEach(function (event) {
    req.prependListener(event, stream.emit.bind(stream, event));
  });
  req.pipe(stream, {
    end: end
  });
};
/**
 * Chooses a format to download.
 *
 * @param {stream.Readable} stream
 * @param {Object} info
 * @param {Object} options
 */


var downloadFromInfoCallback = function downloadFromInfoCallback(stream, info, options) {
  options = options || {};
  var err = utils.playError(info.player_response, ['UNPLAYABLE', 'LIVE_STREAM_OFFLINE', 'LOGIN_REQUIRED']);

  if (err) {
    stream.emit('error', err);
    return;
  }

  if (!info.formats.length) {
    stream.emit('error', Error('This video is unavailable'));
    return;
  }

  var format;

  try {
    format = formatUtils.chooseFormat(info.formats, options);
  } catch (e) {
    stream.emit('error', e);
    return;
  }

  stream.emit('info', info, format);

  if (stream.destroyed) {
    return;
  }

  var contentLength,
      downloaded = 0;

  var ondata = function ondata(chunk) {
    downloaded += chunk.length;
    stream.emit('progress', chunk.length, downloaded, contentLength);
  }; // Download the file in chunks, in this case the default is 10MB,
  // anything over this will cause youtube to throttle the download


  var dlChunkSize = options.dlChunkSize || 1024 * 1024 * 10;
  var req;
  var shouldEnd = true;

  if (format.isHLS || format.isDashMPD) {
    req = m3u8stream(format.url, {
      chunkReadahead: +info.live_chunk_readahead,
      begin: options.begin || format.isLive && Date.now(),
      liveBuffer: options.liveBuffer,
      requestOptions: options.requestOptions,
      parser: format.isDashMPD ? 'dash-mpd' : 'm3u8',
      id: format.itag
    });
    req.on('progress', function (segment, totalSegments) {
      stream.emit('progress', segment.size, segment.num, totalSegments);
    });
    pipeAndSetEvents(req, stream, shouldEnd);
  } else {
    var requestOptions = Object.assign({}, options.requestOptions, {
      maxReconnects: 6,
      maxRetries: 3,
      backoff: {
        inc: 500,
        max: 10000
      }
    });
    var shouldBeChunked = dlChunkSize !== 0 && (!format.hasAudio || !format.hasVideo);

    if (shouldBeChunked) {
      var start = options.range && options.range.start || 0;
      var end = start + dlChunkSize;
      var rangeEnd = options.range && options.range.end;
      contentLength = options.range ? (rangeEnd ? rangeEnd + 1 : parseInt(format.contentLength)) - start : parseInt(format.contentLength);

      var getNextChunk = function getNextChunk() {
        if (!rangeEnd && end >= contentLength) end = 0;
        if (rangeEnd && end > rangeEnd) end = rangeEnd;
        shouldEnd = !end || end === rangeEnd;
        requestOptions.headers = Object.assign({}, requestOptions.headers, {
          Range: "bytes=".concat(start, "-").concat(end || '')
        });
        req = miniget(format.url, requestOptions);
        req.on('data', ondata);
        req.on('end', function () {
          if (stream.destroyed) {
            return;
          }

          if (end && end !== rangeEnd) {
            start = end + 1;
            end += dlChunkSize;
            getNextChunk();
          }
        });
        pipeAndSetEvents(req, stream, shouldEnd);
      };

      getNextChunk();
    } else {
      // Audio only and video only formats don't support begin
      if (options.begin) {
        format.url += "&begin=".concat(parseTimestamp(options.begin));
      }

      if (options.range && (options.range.start || options.range.end)) {
        requestOptions.headers = Object.assign({}, requestOptions.headers, {
          Range: "bytes=".concat(options.range.start || '0', "-").concat(options.range.end || '')
        });
      }

      req = miniget(format.url, requestOptions);
      req.on('response', function (res) {
        if (stream.destroyed) {
          return;
        }

        contentLength = contentLength || parseInt(res.headers['content-length']);
      });
      req.on('data', ondata);
      pipeAndSetEvents(req, stream, shouldEnd);
    }
  }

  stream._destroy = function () {
    stream.destroyed = true;
    req.destroy();
    req.end();
  };
};
/**
 * Can be used to download video after its `info` is gotten through
 * `ytdl.getInfo()`. In case the user might want to look at the
 * `info` object before deciding to download.
 *
 * @param {Object} info
 * @param {!Object} options
 * @returns {ReadableStream}
 */


ytdl.downloadFromInfo = function (info, options) {
  var stream = createStream(options);

  if (!info.full) {
    throw Error('Cannot use `ytdl.downloadFromInfo()` when called ' + 'with info from `ytdl.getBasicInfo()`');
  }

  setImmediate(function () {
    downloadFromInfoCallback(stream, info, options);
  });
  return stream;
};